import { ReactNode } from "react";

import { Box, Flex, useBreakpointValue, useMediaQuery } from "@chakra-ui/react";

import logoSvg from "@assets/img/logo-black-and-white.svg";

import { Logo } from "@components/Logo";

import NavItem from "../NavItem/NavItem.tsx";

export const HEADER_HEIGHT = 16;
export const HEADER_HEIGHT_MOBILE = 12;

interface NavItem {
    id: string | number;
    name: string;
    route: string;
    isExternal?: boolean;
}

interface HeaderProps {
    logoHref?: string;
    navItems?: NavItem[];
    profileMenu?: ReactNode;
    mobileNav?: ReactNode;
    backgroundColor?: string;
    showBottomBorder?: boolean;
}

const Header = ({
    logoHref = "#",
    navItems = [],
    profileMenu,
    mobileNav,
    backgroundColor = "base.300",
    showBottomBorder = true
}: HeaderProps) => {
    const [isMediumDevice] = useMediaQuery([
        "(min-width: 768px) and (max-width: 1100px)"
    ]);
    const isMobile =
        useBreakpointValue({ base: true, md: false }) || isMediumDevice;

    return (
        <Flex
            position="sticky"
            top={0}
            zIndex={999}
            css={{
                position: "-webkit-sticky",
                WebkitTransform: "translateZ(0)",
                transform: "translateZ(0)"
            }}
            height={{ base: HEADER_HEIGHT_MOBILE, md: HEADER_HEIGHT }}
            borderBottom={showBottomBorder ? "1px" : "none"}
            borderBottomStyle={showBottomBorder ? "solid" : "none"}
            borderBottomColor={showBottomBorder ? "lines" : "transparent"}
            paddingLeft={{ base: 2, md: 10 }}
            paddingRight={{ base: 4, md: 10 }}
            py={4}
            bg={backgroundColor}
            justify="space-between"
            alignContent="center"
            wrap="nowrap"
            alignItems="center"
            w="100%"
            _dark={{
                bg: "base.800",
                borderBottomColor: showBottomBorder ? "base.600" : "transparent"
            }}
        >
            <Logo
                variant="inline"
                src={logoSvg}
                backgroundColor="transparent"
                size="lg"
                data-testid="logoImg"
                href={logoHref}
                isDarkMint
            />
            {navItems.length > 0 && (
                <>
                    {isMobile ? (
                        <Flex>{mobileNav}</Flex>
                    ) : (
                        <Flex
                            gap="2rem"
                            alignItems="center"
                            marginInline="auto"
                        >
                            {navItems.map(item => (
                                <NavItem
                                    key={item.id}
                                    url={item.route}
                                    linkText={item.name}
                                    isExternal={item.isExternal}
                                    dataTrackingName={item.name}
                                />
                            ))}
                        </Flex>
                    )}
                </>
            )}

            {profileMenu && !isMobile && <Box>{profileMenu}</Box>}
        </Flex>
    );
};

export default Header;
